module.exports = __webpack_public_path__ + "static/media/walking7.23fde989.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/walking7.png
// module id = 2044
// module chunks = 0